const colors = {
  bgColor: "#000000",
  red: "#FF0101",
  mainBlue: "#8B9FC2",
  subBlue: "#3D5F99",
  bannerBlue: "#004AC9",
  logoBlue: "#63ABE5",
  darkBlue: "#5295CA",
  green: "#12C338",
  gray: "#191B24",
  silver: "#808080",
  lightgray: "#D3D3D3",
  black: "#000000",
  white: "#ffffff",
  darkslateblue: "#484A64",
  darkgray: "#2a2a3a",
  postgray: "#262626",
  postgray2: "#959595",
  postgray3: "#D2CDBC",
  postgray4: "#4C4C4C",
  postgray5: "#635E5E",
  postgray6: "#949494",
  navy:"#949494",
};

export default colors